<template>
    <div class="mb-5">
        <div class="__heading d-flex">
            <h2>General Liability Insurance</h2>

            <v-tooltip top content-class="charge-text__tooltip">
                <template v-slot:activator="{ on, attrs }">
                    <img v-bind="attrs" v-on="on" src="assets/icons/info.svg" alt="info icon" width="12"
                         class="ml-1">
                </template>
                <span class="custom--v-tooltip">
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad aut delectus, dignissimos ex id quod?
                </span>
            </v-tooltip>
        </div>
        <v-row>
            <v-col xl="3" lg="3" md="6" sm="12" cols="12">
                <h4>Policy number</h4>

                <v-text-field
                    v-model="general_liability_license_data.policy_number"
                    dense
                    outlined
                    placeholder="Write a number"
                    class="custom--v-text-field"
                    :error-messages="policyNumberErrors"
                    @input="$v.general_liability_license_data.policy_number.$touch()"
                    @blur="$v.general_liability_license_data.policy_number.$touch()"
                >
                </v-text-field>
            </v-col>
            <v-col xl="3" lg="3" md="6" sm="12" cols="12">
                <h4>Policy issuer</h4>

                <v-text-field
                    v-model="general_liability_license_data.policy_issuer"
                    dense
                    outlined
                    placeholder="Write a issue"
                    class="custom--v-text-field"
                    :error-messages="policyIssueErrors"
                    @input="$v.general_liability_license_data.policy_issuer.$touch()"
                    @blur="$v.general_liability_license_data.policy_issuer.$touch()"
                >
                </v-text-field>
            </v-col>
            <v-col xl="3" lg="3" md="6" sm="12" cols="12">
                <h4>Expiration date</h4>

                <date-picker
                    :expiration_date="general_liability_license_data.expiration_date"
                    :is-clicked-submit="isSubmit"
                    @onChange="(value) => { this.general_liability_license_data.expiration_date = value }"/>
            </v-col>
            <v-col xl="3" lg="3" md="6" sm="12" cols="12" class="d-flex align-center">
                <v-btn depressed color="secondary"
                       class="custom--v-btn"
                       min-width="80"
                       @click="submit( general_liability_license_data)"
                >
                    Save
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import DatePicker from "../../components/DatePicker.vue";

export default {
    name: "CredentialsGeneralLiability",

    components: { DatePicker },

    props: {
        branchId: {
            type:Number,
            required: true
        },
    },

    mixins: [validationMixin],

    validations: {
        general_liability_license_data: {
            policy_number: { required },
            policy_issuer: { required },
            expiration_date: { required }
        }
    },

    data () {
        return {
            general_liability_license_data: {
                policy_number: '',
                policy_issuer: '',
                expiration_date: ''
            },
            isSubmit: false
        }
    },

    computed: {
        ...mapGetters('credentials', ['general_liability_license']),

        policyNumberErrors () {
            const errors = [];
            if (! this.$v.general_liability_license_data.policy_number.$dirty) return errors;
            ! this.$v.general_liability_license_data.policy_number.required && errors.push('Field is required');
            return errors
        },

        policyIssueErrors () {
            const errors = [];
            if (! this.$v.general_liability_license_data.policy_issuer.$dirty) return errors;
            ! this.$v.general_liability_license_data.policy_issuer.required && errors.push('Field is required');
            return errors
        }
    },

    methods: {
        ...mapActions('credentials', ['update']),

        submit (general_liability_license_data) {
            this.$v.$touch();
            this.isSubmit = true;

            //if invalid return false
            if (this.$v.$invalid) {
                return false;
            }

            this.update({
                data_name: 'general_liability_license',
                data: general_liability_license_data
            })
        }
    },

    created () {
        if (this.general_liability_license) {
            this.general_liability_license_data = this.general_liability_license;
        }
    }
}
</script>